export const env = {
  IS_DEV: process.env.NODE_ENV === 'development',
  PUBLIC_SUPABASE_URL: process.env.BUN_PUBLIC_SUPABASE_URL ?? '',
  PUBLIC_SUPABASE_ANON_KEY: process.env.BUN_PUBLIC_SUPABASE_ANON_KEY ?? '',
  PUBLIC_API_V1_BASE_URL: process.env.BUN_PUBLIC_API_V1_BASE_URL ?? '',
};
